import { useApplicationField } from '../useApplicationField';

// ─── Property Management Company ──────────────────────────────────────────────

export const useBorrowerPmcName = () =>
    useApplicationField(
        (d) => d.information.borrower.propertyManagementCompany.name,
        (d, v) => ({ ...d, information: { ...d.information, borrower: { ...d.information.borrower, propertyManagementCompany: { ...d.information.borrower.propertyManagementCompany, name: v } } } })
    );

export const useBorrowerPmcWebsite = () =>
    useApplicationField(
        (d) => d.information.borrower.propertyManagementCompany.website,
        (d, v) => ({ ...d, information: { ...d.information, borrower: { ...d.information.borrower, propertyManagementCompany: { ...d.information.borrower.propertyManagementCompany, website: v } } } })
    );

export const useBorrowerPmcHandleMode = () =>
    useApplicationField(
        (d) => d.information.borrower.propertyManagementCompany.managementAgreement.handleMode,
        (d) => d
    );

// ─── Management Agreement File ────────────────────────────────────────────────

export function useBorrowerManagementAgreementFile() {
    const [handleMode, setHandleMode] = useApplicationField(
        (d) => d.information.borrower.propertyManagementCompany.managementAgreement?.handleMode,
        (d, v) => ({
            ...d,
            information: {
                ...d.information,
                borrower: {
                    ...d.information.borrower,
                    propertyManagementCompany: {
                        ...d.information.borrower.propertyManagementCompany,
                        managementAgreement: {
                            ...(d.information.borrower.propertyManagementCompany?.managementAgreement ?? {}),
                            handleMode: v,
                        },
                    },
                },
            },
        })
    );
    const [filename, setFilename] = useApplicationField(
        (d) => d.information.borrower.propertyManagementCompany.managementAgreement?.uploadedFilename,
        (d, v) => ({
            ...d,
            information: {
                ...d.information,
                borrower: {
                    ...d.information.borrower,
                    propertyManagementCompany: {
                        ...d.information.borrower.propertyManagementCompany,
                        managementAgreement: {
                            ...(d.information.borrower.propertyManagementCompany?.managementAgreement ?? {}),
                            uploadedFilename: v,
                        },
                    },
                },
            },
        })
    );
    const [fileApiId, setFileApiId] = useApplicationField(
        (d) => d.information.borrower.propertyManagementCompany.managementAgreement?.uploadedFileApiId,
        (d, v) => ({
            ...d,
            information: {
                ...d.information,
                borrower: {
                    ...d.information.borrower,
                    propertyManagementCompany: {
                        ...d.information.borrower.propertyManagementCompany,
                        managementAgreement: {
                            ...(d.information.borrower.propertyManagementCompany?.managementAgreement ?? {}),
                            uploadedFileApiId: v,
                        },
                    },
                },
            },
        })
    );
    return { handleMode, setHandleMode, filename, setFilename, fileApiId, setFileApiId };
}
